import { createStore } from 'vuex'
import getters from './getters'
import user from './modules/user.js'
import common from './modules/common'
import bigScreen from './modules/big-screen'

export default createStore({
    modules: {
        user,
        common,
        bigScreen
    },
    getters
})
